import { createSelector } from 'reselect';
import { RootState } from 'store/types';

/**
 * Download Pathology Results
 */
export const pathologyDetailsDownloadsSelector = (state: RootState) =>
  state.testResults.downloadPathologyDetails;

export const pathologyDetailsDownloadingSelector = createSelector(
  pathologyDetailsDownloadsSelector,
  testResults => testResults.isDownloadingPathologyDetails
);

export const pathologyDetailsDownloadDataSelector = createSelector(
  pathologyDetailsDownloadsSelector,
  testResults => testResults.data
);

/**
 * Share Pathology Results
 */
export const sharePathologyResultsSelector = (state: RootState) =>
  state.testResults.sharePathologyResults;

export const sharePathologyResultsDataSelector = createSelector(
  sharePathologyResultsSelector,
  sharePathologyResults => sharePathologyResults.sharedPathologyResultsData
);

export const sharePathologyResultsSendingSelector = createSelector(
  sharePathologyResultsSelector,
  sharePathologyResults => sharePathologyResults.isSendingPathologyResults
);
